<template>
  <div>
    <b-modal v-model="modalPregunta" :title="this.mensajes[0].valor">
      <b-container fluid>
        <b-row class="mb-1">
          <label for="input-live">{{ this.mensajes[0].valor }}</label>
        </b-row>
      </b-container>
      <template #modal-footer>
        <div class="w-100">
          <b-button size="sm" variant="success">
            {{ this.mensajes[1].valor }}
          </b-button>
          <b-button size="sm"  variant="danger">
            {{ this.mensajes[2].valor }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import {
  BButton,
  BModal,
  BContainer,
  BFormInput,
  BRow,
  BCol
} from 'bootstrap-vue'
// import { decode } from 'punycode'
// const SECRET = 'e2ab018979a3c007014c10efb3b0c3fee'
export default {
  name: 'moduleExpired',
  components: {
    BButton,
    BModal,
    BContainer,
    BFormInput,
    BRow,
    BCol
  },
  data () {
    return {
      // Get device width and height
      token: null,
      mensajes: []
    }
  },
  created () {
    // Add mensajes from DB
    const mensajesLocales = JSON.parse(localStorage.getItem('msgModalExpired'))
    this.mensajes = mensajesLocales.filter(mens => {
      if (mens.modulo === 'modalExpired') {
        return mens
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modalExpired.vue